import React, { ReactNode } from 'react';
import { UserName } from 'features/UserCard';
import { Avatar } from 'shared/ui/Avatar';

import styles from '../UserOverviewWidget.module.scss';
import { DataType } from '../UserOverviewWidget.types';

const getUserOverviewNameCell = ({ firstName, lastName, picture, id }: DataType['name']): ReactNode => {
  const fullName = `${firstName} ${lastName}`;

  return (
    <div className={styles.nameCellRootWrapper}>
      <div className={styles.avatar}>
        <Avatar picture={picture} text={fullName} size={24} />
      </div>
      <UserName name={fullName} id={id} />
    </div>
  );
};

export default getUserOverviewNameCell;
